"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenesysPropertiesSelectorComponent = GenesysPropertiesSelectorComponent;
const React = __importStar(require("react"));
const R = __importStar(require("ramda"));
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const PropertiesSelector = __importStar(require("../react-properties-selector"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const Contexts = __importStar(require("../contexts"));
const GenesysPropertiesSelectorTypes = __importStar(require("../genesys-properties-selector-types"));
const Actions = __importStar(require("./actions"));
const filter_pretty_print_1 = require("../filter-pretty-print");
const quantity_conversion_1 = require("./quantity-conversion");
const context_provider_1 = require("./context-provider");
function GenesysPropertiesSelectorComponent({ lockSingleValidValue, activatedQuantitySelectors, closedGroups, customTranslation, dispatch, hidePropertyNames = false, includeCodes, includeHiddenProperties, layoutRenderer, measureSystem, onChange, onPropertyFormatChanged, onPropertyFormatCleared, originalProductProperties, getAmountFormat, groupFilter, propertyFormats, quantityDefaults, readOnlyProperties = [], sections, selectedProperties, uniqueId, onDelete, fieldGroup, valueSources, showGroups, showDelete }) {
    return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => {
        const translateGroupName = (groupName) => {
            return translate(LanguageTexts.globalPropertyName(groupName));
        };
        const defaultTranslation = {
            propertyName: (propertyName, translateArg) => translateArg(LanguageTexts.globalPropertyName(propertyName)),
            propertyValue: (propertyName, propertyValue, translateArg) => translateArg(LanguageTexts.globalPropertyName(propertyName + "_" + propertyValue)),
            propertyDescription: (propertyName, translateArg) => translateArg(LanguageTexts.globalPropertyDescription(propertyName)),
            propertyValueDescription: (propertyName, propertyValue, translateArg) => translateArg(LanguageTexts.globalPropertyDescription(propertyName + "_" + propertyValue))
        };
        const translation = customTranslation
            ? Object.assign(Object.assign({}, defaultTranslation), customTranslation) : defaultTranslation;
        const conversionParamaterByPropertyName = originalProductProperties.reduce((soFar, current) => soFar.set(current.name, current.conversionParameters), new Map());
        const renderProperties = createRenderProperties(includeHiddenProperties, originalProductProperties, selectedProperties);
        // Get sorder before filtering visible properties
        const sortedGroupKeys = R.uniq(originalProductProperties
            .concat()
            .sort((a, b) => a.sort_no - b.sort_no)
            .map(p => p.group || GenesysPropertiesSelectorTypes.NO_GROUP));
        const renderGroups = createRenderGroups(dispatch, translateGroupName, uniqueId, closedGroups, renderProperties, sortedGroupKeys);
        const renderSections = createRenderSections(renderGroups, sections);
        const extraProps = {
            //
            uniqueId,
            productProperties: originalProductProperties,
            sections: renderSections,
            hidePropertyNames,
            propertyFormats,
            onDelete,
            fieldGroup,
            showDelete
        };
        const filterPrettyPrint = (0, filter_pretty_print_1.createFilterPrettyPrint)(translation.propertyName, translation.propertyValue, translate, getAmountFormat, fieldGroup, propertyName => conversionParamaterByPropertyName.get(propertyName));
        const fieldNameMap = renderProperties.reduce((a, b) => {
            a[b.propertyName] = b.fieldName || b.propertyName;
            return a;
        }, {});
        const mappedOnPropertyFormatChanged = (propertyName, unit, decimalCount) => onPropertyFormatChanged(fieldNameMap[propertyName], unit, decimalCount);
        const mappedOnPropertyFormatCleared = (propertyName) => onPropertyFormatCleared(fieldNameMap[propertyName]);
        const propertiesSelectorProps = {
            //
            units: uom_1.Units,
            unitLookup: uom_1.unitLookup,
            lockSingleValidValue,
            includeHiddenProperties,
            includeCodes,
            selectedProperties,
            filterPrettyPrint,
            productProperties: originalProductProperties,
            propertyFormats,
            readOnlyProperties,
            onChange: onChange,
            onPropertyFormatCleared: mappedOnPropertyFormatCleared,
            onPropertyFormatChanged: mappedOnPropertyFormatChanged,
            onPropertyFormatSelectorToggled: (propertyName) => {
                dispatch(Actions.toggleQuantitySelector(uniqueId, propertyName));
            },
            translatePropertyName: (propertyName) => {
                return translation.propertyName(propertyName, translate);
            },
            translatePropertyValue: (propertyName, value) => {
                return translation.propertyValue(propertyName, value, translate);
            },
            translateGroupName,
            LayoutRenderer: layoutRenderer,
            unitsFormat: uom_1.UnitsFormat,
            comparer: property_1.compare
        };
        return (React.createElement(context_provider_1.ContextProvider, { activatedQuantitySelectors: activatedQuantitySelectors, fieldGroup: fieldGroup, filterPrettyPrint: filterPrettyPrint, getAmountFormat: getAmountFormat, groupFilter: groupFilter, showGroups: showGroups, layoutRendererExtraProps: extraProps, productProperties: originalProductProperties, onQuantityChange: (0, quantity_conversion_1.createOnQuantityChange)(onPropertyFormatChanged, measureSystem, quantityDefaults), valueSources: valueSources, translatePropertyValue: (propertyName, propertyValue) => translation.propertyValue(propertyName, propertyValue, translate), translatePropertyDescription: (propertyName) => translation.propertyDescription(propertyName, translate), translatePropertyValueDescription: (propertyName, propertyValue) => translation.propertyValueDescription(propertyName, propertyValue, translate), fieldNameMap: fieldNameMap },
            React.createElement(PropertiesSelector.PropertiesSelector, Object.assign({}, propertiesSelectorProps))));
    }));
}
function createRenderSections(renderGroups, sections) {
    if (sections === undefined) {
        const renderSection = {
            key: GenesysPropertiesSelectorTypes.NO_GROUP,
            groups: renderGroups
        };
        return [renderSection];
    }
    return Object.keys(sections).reduce((soFar, sectionKey) => {
        const section = sections[sectionKey];
        const sectionGroups = section.groups.reduce((groups, groupKey) => {
            groups.push(...renderGroups.filter(rg => rg.key === groupKey));
            return groups;
        }, []);
        const renderSection = {
            key: sectionKey,
            groups: sectionGroups
        };
        soFar.push(renderSection);
        return soFar;
    }, []);
}
function createRenderGroups(dispatch, translateGroupName, uniqueId, closedGroups, 
// biome-ignore lint: -
renderProperties, sortedGroupKeys) {
    const renderGroups = sortedGroupKeys.reduce((soFar, groupKey) => {
        const renderGroup = {
            key: groupKey,
            isCollapsed: !!closedGroups[groupKey],
            properties: renderProperties.filter(rp => rp.group === groupKey),
            onToggle: () => {
                dispatch(Actions.toggleGroup(uniqueId, groupKey));
            },
            translatedName: translateGroupName(groupKey)
        };
        if (renderGroup.properties.length > 0) {
            soFar.push(renderGroup);
        }
        return soFar;
    }, []);
    return renderGroups;
}
function createRenderProperties(includeHiddenProperties, productProperties, selectedProperties) {
    const renderProperties = productProperties
        .filter(pp => includeHiddenProperties ||
        property_1.PropertyFilter.isValid(selectedProperties, pp.visibility_filter))
        .map(property => {
        const renderProperty = {
            sortNo: property.sort_no,
            propertyName: property.name,
            group: property.group
                ? property.group
                : GenesysPropertiesSelectorTypes.NO_GROUP,
            fieldName: property.fieldName || property.name
        };
        return renderProperty;
    })
        .sort((a, b) => a.sortNo - b.sortNo);
    return renderProperties;
}
//# sourceMappingURL=genesys-properties-selector-component.js.map